<template>
  <CModal
    :show.sync="showModal"
    :no-close-on-backdrop="true"
    :centered="true"
    title="Modal title 2"
    size="lg"
    :color="configModal.color"
  >
    {{ configModal.contenido }}
    <template #header>
      <h6 class="modal-title">{{ configModal.titulo }}</h6>
      <CButtonClose @click="changeModalState" class="text-white" />
    </template>
    <template #footer>
      <CButton @click="changeModalState" :color="configModal.color">{{
        configModal.boton
      }}</CButton>
    </template>
  </CModal>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Modals",

  computed: {
    showModal() {
      return this.$store.getters.toggleModal;
    },
    ...mapState(["configModal"]),
  },
  methods: {
    changeModalState() {
      var payload = {
        muestra: false,
      };
      this.$store.commit("showModal", payload);
    },
  },
};
</script>